"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.stripe.info': 'Proszę dokończyć płatność używając Stripe Elements poniżej.',
    'payment.stripe.clientSecret': 'Klucz Klienta',
    'payment.stripe.noClientSecret': 'Brak dostępnego klucza klienta Stripe',
};
